import { useEffect } from 'react';

import { TAdBannerEventPrefix } from 'shared/types/events';
import { getEventQueue } from 'shared/utils/eventQueue';

interface IUseAdBannerMicrofrontendEventsParams {
  placeId: string;
  isReady: boolean;
  onStub?(): void;
  onError?(): void;
}

/**
 * Подписывает хост на lifecycle-события микрофронтенда. Топики ключуются тем же
 * `placeId`, который уезжает в `<Microfrontend parameters={...} />`.
 */
export function useAdBannerMicrofrontendEvents({
  placeId,
  isReady,
  onStub,
  onError,
}: IUseAdBannerMicrofrontendEventsParams): void {
  useEffect(() => {
    if (!isReady || (!onStub && !onError)) {
      return undefined;
    }

    const eventQueue = getEventQueue();
    const prefix: TAdBannerEventPrefix = `ad-banner-frontend-reporting.v1.${placeId}.ad-banner-`;
    const stubEventName = `${prefix}stub` as const;
    const errorEventName = `${prefix}error` as const;

    if (onStub) {
      eventQueue.on(stubEventName, onStub);
    }

    if (onError) {
      eventQueue.on(errorEventName, onError);
    }

    return () => {
      if (onStub) {
        eventQueue.off(stubEventName, onStub);
      }

      if (onError) {
        eventQueue.off(errorEventName, onError);
      }
    };
  }, [placeId, isReady, onStub, onError]);
}
